import { render, staticRenderFns } from "./VpAccounts.vue?vue&type=template&id=3eb02117"
import script from "./VpAccounts.vue?vue&type=script&lang=js"
export * from "./VpAccounts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports